import { Box, Button, Grid, Modal, Typography } from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import React from 'react';

interface DeleteModalProps {
  open: any;
  handleCloseModal: (args?: any) => void;
  handleDelete: (args?: any) => void;
}

const style = {
  // eslint-disable-next-line @typescript-eslint/prefer-as-const
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const boxStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};

const DeleteModal = ({ open, handleDelete, handleCloseModal }: DeleteModalProps) => {
  return (
    <Modal
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box sx={boxStyle}>
          <WarningIcon color="warning" sx={{ height: 100, width: 100 }} />
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you sure?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            This action cannot be undone.
          </Typography>
          <Box height={10} />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Button color="error" fullWidth onClick={handleDelete}>
                Delete
              </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
              <Button fullWidth onClick={handleCloseModal}>
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Modal>
  );
};

export default DeleteModal;
